import { sortAppointmentsByTimeAsc } from '.';

export default function getSaturdayAppointmets(appointments) {
    const filterSaturdayAppointments = appointments.filter(
        item => new Date(item.data.date).getDay() === 6,
    );
    return sortAppointmentsByTimeAsc(filterSaturdayAppointments);
}
